const _ = require('lodash');

class StoreFilterService {
    setDivisions(divisions) {
        this.divisions = divisions;
    }

    setFacilities(facilities) {
        this.facilities = facilities;
    }

    getSelectedDivisions(divisions = this.divisions) {
        return _.filter(divisions, 'Selected');
    }

    getDivisionCodes(divisions = this.getSelectedDivisions()) {
        return _.map(divisions, 'Division');
    }

    getSelectedFacilities(facilities = this.facilities) {
        return _.filter(facilities, 'Selected');
    }

    getFacilityCodes(facilities = this.getSelectedFacilities()) {
        return _.map(facilities, 'Facility');
    }

    isStoreMatching(store) {
        const isInDivision = _.includes(this.getDivisionCodes(), store.Division);

        const selectedFacilityLabels = _.map(this.getSelectedFacilities(), 'Label');
        const hasAllFacilities = (
            !selectedFacilityLabels.length
            || _.intersection(selectedFacilityLabels, store.Facilities).length >= selectedFacilityLabels.length
        );

        return isInDivision && hasAllFacilities;
    }
}

module.exports = StoreFilterService;



// WEBPACK FOOTER //
// ./src/shop/stores/store-filter.service.js